/**
 * Server-side utilities for @chipi-stack/nextjs/server
 *
 * Import server utilities from '@chipi-stack/nextjs/server' to avoid mixing client/server code.
 *
 * @example
 * ```ts
 * // In your API routes or Server Components
 * import { createChipiServer, getChipiServer } from '@chipi-stack/nextjs/server';
 *
 * const chipiServer = getChipiServer();
 * const wallets = await chipiServer.getWallets();
 * ```
 */

// Server SDK management
export {
  createChipiServer,
  getChipiServer,
  resetChipiServer,
} from "./createChipiServer";
